import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo2_Maria } from '../../../../../utils/ES/Modals/directors';

const ModalVideoMaria2 = () => {
  return (
    <>
      <ModalVideo
        id="maria-video-2"
        dataText={TextVideo2_Maria}
        videoSrc="https://player.vimeo.com/video/640530132?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_MARIA_2"
      />
    </>
  );
};

export default ModalVideoMaria2;
